import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import MunicipalidadHeader from '../components/Header/MunicipalidadHeader';
import { listAreaMunicipalSitioWeb } from '@/api/municipalidadAPI';
import Area from '../components/Areas/Area';
import './AreasView.css';

const AreasView = () => {
  const [areas, setAreas] = useState(null);

  useEffect(() => {
    listAreaMunicipalSitioWeb()
      .then((response) => {
        setAreas(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  return (
    <>
      <MunicipalidadHeader tipo="Gobierno" title="Áreas"></MunicipalidadHeader>
      <Container className="content pagina-interna">
        <Row>
          {areas !== null &&
            areas.length > 0 &&
            areas.map((item, idx) => (
              <Col lg="4" key={idx}>
                <Area item={item}></Area>
              </Col>
            ))}
        </Row>
      </Container>
    </>
  );
};

export default React.memo(AreasView);
